mutation DocumentFolderUpdate($input: DocumentPoolUpdateInput!) {
  documentPoolUpdate(input: $input) {
    documentPools {
      id
      name
    }
  }
}